import type { ApiResponse, User } from '../../types/api';

import { baseApi } from './baseApi';

interface SendCodeRequest {
  telegramId: number;
}

interface SendCodeResponse {
  message: string;
}

interface VerifyCodeRequest {
  telegramId: number;
  code: string;
}

interface VerifyCodeResponse {
  token: string;
  user: User;
}

interface TelegramLinkLoginRequest {
  tg_token: string;
}

type TelegramLinkLoginResponse = VerifyCodeResponse;

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Send verification code
    sendCode: builder.mutation<ApiResponse<SendCodeResponse>, SendCodeRequest>({
      query: (body) => ({
        url: '/auth/send-code',
        method: 'POST',
        body,
      }),
    }),
    // Verify code and login
    verifyCode: builder.mutation<ApiResponse<VerifyCodeResponse>, VerifyCodeRequest>({
      query: (body) => ({
        url: '/auth/verify-code',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    telegramLinkLogin: builder.mutation<ApiResponse<TelegramLinkLoginResponse>, TelegramLinkLoginRequest>({
      query: (body) => ({
        url: '/auth/telegram-link-login',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
    // Get current user info
    getMe: builder.query<ApiResponse<{ user: User }>, void>({
      query: () => ({
        url: '/auth/me',
        method: 'GET',
      }),
      providesTags: ['User'],
    }),
  }),
});

export const { useSendCodeMutation, useVerifyCodeMutation, useTelegramLinkLoginMutation, useGetMeQuery } = authApi;
